// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"1b5c14be","201":"43beba9c","587":"d3d7c90e","719":"c37ce154","725":"6e0b45dd","779":"1e688ce0","988":"36804fc5"}[chunkId] + ".chunk.css";
};